module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 23@2x.ab704dea.png";